import { type FC } from 'react'
import { Form } from 'react-bootstrap'
import { ariaDescribedByIds, deepEquals, type WidgetProps } from '@rjsf/utils'
import { fieldNameOf, requiredLabel } from '../displayLabel'

export const CheckboxGroupWidget: FC<WidgetProps> = ({ id, label, value, schema, options, required, disabled, readonly, rawErrors, onChange }) => {
  const enumOptions = options.enumOptions ?? []
  const selected: unknown[] = Array.isArray(value) ? value : []
  const enumDisabled: unknown[] = Array.isArray(options.enumDisabled) ? options.enumDisabled : []

  const toggle = (optionValue: unknown, checked: boolean) => {
    const isIn = (values: unknown[], candidate: unknown) => values.some((current) => deepEquals(current, candidate))
    const next = checked ? [...selected, optionValue] : selected.filter((current) => !deepEquals(current, optionValue))
    onChange(enumOptions.map((option) => option.value).filter((value) => isIn(next, value)))
  }

  return (
    <div
      id={id}
      role='group'
      aria-label={requiredLabel(fieldNameOf(id, label, schema, options.listItem), required)}
      aria-describedby={ariaDescribedByIds(id)}
      className='d-flex flex-column zocks-gap-0.5'
    >
      {enumOptions.map((option, index) => (
        <Form.Check
          key={index}
          id={`${id}-${index}`}
          type='checkbox'
          label={option.label}
          checked={selected.some((current) => deepEquals(current, option.value))}
          disabled={disabled || readonly || enumDisabled.some((disabledValue) => deepEquals(disabledValue, option.value))}
          isInvalid={Boolean(rawErrors?.length)}
          onChange={(event) => toggle(option.value, event.target.checked)}
        />
      ))}
    </div>
  )
}
